import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "./LegalTopBar.css";

export default function LegalTopBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from === "app" ? "app" : "public";

  const goBack = () => {
    // Si hay historial, vuelve; si no, usa fallback por variante
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(from === "app" ? "/dashboard" : "/");
    }
  };

}
